module.exports = __webpack_public_path__ + "assets/amazon-s3.0449b517.svg";